import { Observable } from 'rxjs';

export class FilterSelection {
  private _brand: any;
  private _subbrand: any;
  private _line: any;
  private _format: any;

  private _seller: any;
  private _country: any;
  private _region: any;
  private _subregion: any;

  private _skipToken: number;

  private _tamName: any;
  private _tam: any;

  constructor() {
    this._subbrand = '';
    this._line = '';
    this._format = '';
    this._brand = '';
    this.region = '';
    this.subregion = '';
    this._country = '';
    this._skipToken = 1000;
    this._tamName = '';
    this._tam = '';
  }

  public set subregion(value: any) {
    this._subregion = value;
  }
  public get subregion() {
    return this._subregion;
  }
  public set region(value: any) {
    this.subregion = '';
    this._region = value;
  }
  public get region() {
    return this._region;
  }
  public set country(value: any) {
    this.region = '';
    this.subregion = '';
    this._country = value;
  }
  public get country() {
    return this._country;
  }
  public set seller(value: any) {
    this._seller = value;
  }
  public get seller() {
    return this._seller;
  }
  public set tamName(value: any) {
    this._tamName = value;
  }
  public get tamName() {
    return this._tamName;
  }
  public set tam(value: any) {
    this._tam = value;
  }
  public get tam() {
    return this._tam;
  }
  public set format(value: any) {
    this._format = value;
  }
  public get format() {
    return this._format;
  }
  public set line(value: any) {
    this._format = '';
    this._line = value;
  }
  public get line() {
    return this._line;
  }

  public set subbrand(value: any) {
    this._line = '';
    this._format = '';
    this._subbrand = value;
  }
  public get subbrand() {
    return this._subbrand;
  }

  public set brand(value: any) {
    this._subbrand = '';
    this._line = '';
    this._format = '';
    this._brand = value;
  }
  public get brand() {
    return this._brand;
  }

  public set skipToken(value: any) {
    this._skipToken = value;
  }

  public get skipToken(): any {
    return this._skipToken;
  }
}
